import DocumentoEditorTextoUrlBuilder from '@/core/utils/factory/documentos/editor-texto/DocumentoEditorTextoUrlBuilder'
import DocumentoAnexosUrlBuilder from '@/core/utils/factory/documentos/anexos/DocumentoAnexosUrlBuilder'
import DocumentoProcessoDigitalUrlBuilder from '@/core/utils/factory/documentos/processo-digital/DocumentoProcessoDigitalUrlBuilder'
import SignatariosDocumentoAnexosUrlBuilder from '@/core/utils/factory/documentos/signatarios/SignatariosDocumentoAnexosUrlBuilder'
import DesentranhamentoDocumentoUrlBuilder from '@/core/utils/factory/documentos/processo-digital/desentranhamento/DesentranhamentoDocumentoUrlBuilder'
import DocumentoPncpUrlBuilder from '@/core/utils/factory/documentos/pncp/DocumentoPncpUrlBuilder'

class DocumentosUrlBuilder {
	tipo

	constructor(tipo) {
		this.tipo = tipo
		this.anexo = new DocumentoAnexosUrlBuilder(this.tipo)
		this.editorTexto = new DocumentoEditorTextoUrlBuilder(this.tipo)
		this.processoDigital = new DocumentoProcessoDigitalUrlBuilder(this.tipo)
		this.signatarios = new SignatariosDocumentoAnexosUrlBuilder(this.tipo)
		this.desentranhamento = new DesentranhamentoDocumentoUrlBuilder(this.tipo)
		this.pncp = new DocumentoPncpUrlBuilder(this.tipo)
	}

	getUrlBuscaPaginada(idEntidade) {
		return `api/${this.tipo.path}/${idEntidade}/documentos`
	}

	getUrlExcluir(idDocumento) {
		return `api/${this.tipo.path}/documentos/${idDocumento}`
	}

	getUrlBaixar(idDocumento) {
		return `api/${this.tipo.path}/documentos/${idDocumento}/baixar`
	}

	getUrlCancelar(objCancelar) {
		return `api/${this.tipo.path}/documentos/${objCancelar.idEntidade}/processo-digital/cancelar`
	}
}

export default DocumentosUrlBuilder
